export default __webpack_public_path__ + "images/IT.d35fcd0.png";